import { EventType } from "src/app/core/models/EventType"

export interface Poster {
    id: string,
    types: EventType[]
}

export const Posters: Poster[] = [
    { id: "1", types: [EventType.SPORT, EventType.MULTI, EventType.CULTURE] },
    { id: "2", types: [EventType.SPORT] },
    { id: "3", types: [EventType.SPORT] },
    { id: "4", types: [EventType.SPORT, EventType.MULTI] },
    { id: "5", types: [EventType.SPORT, EventType.MULTI] },
    { id: "6", types: [EventType.CULTURE] },
    { id: "7", types: [EventType.SPORT] },
    { id: "8", types: [EventType.SPORT, EventType.MULTI] },
    { id: "9", types: [EventType.SPORT] },
    { id: "10", types: [EventType.CULTURE] },
    { id: "11", types: [EventType.SPORT, EventType.MULTI] },
    { id: "12", types: [EventType.SPORT, EventType.MULTI] },
    { id: "13", types: [EventType.SPORT] },
    { id: "14", types: [EventType.SPORT] },
    { id: "15", types: [EventType.CULTURE] },
    { id: "16", types: [EventType.CULTURE] },
    { id: "17", types: [EventType.CULTURE] },
    { id: "18", types: [EventType.SPORT, EventType.MULTI] },
    { id: "19", types: [EventType.SPORT] },
    { id: "20", types: [EventType.SPORT, EventType.MULTI] },
    { id: "21", types: [EventType.CULTURE] },
    { id: "22", types: [EventType.SPORT] },
    { id: "23", types: [EventType.SPORT, EventType.MULTI] },
    { id: "24", types: [EventType.SPORT, EventType.MULTI] },
    { id: "25", types: [EventType.CULTURE] },
    { id: "26", types: [EventType.SPORT, EventType.MULTI] },
    { id: "27", types: [EventType.SPORT, EventType.MULTI] },
    { id: "28", types: [EventType.CULTURE] },
    { id: "29", types: [EventType.SPORT, EventType.MULTI] },
    { id: "30", types: [EventType.SPORT] },
    { id: "31", types: [EventType.SPORT, EventType.MULTI] },
    { id: "32", types: [EventType.CULTURE] },
    { id: "33", types: [EventType.SPORT] }
]
